import { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { useReCaptcha } from "next-recaptcha-v3";
import { fetchPostEmailSendContact, fetchGetCompanySubsidiaries } from "../../../services/api";

export default function ContactUsContactForm({ company }) {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("contactSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendContact({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtMessage', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }

    const [subsidiaries, setSubsidiaries] = useState([])

    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet,
                    phone: item.phone,
                    phone2: item.phone2,
                    whatsapp: item.whatsapp,
                    whatsapp2: item.whatsapp2,
                    whatsappDefaultMessage: item.whatsappDefaultMessage
                }))
                setSubsidiaries(subs)
            })
    }, [])

    const formatPhone = (phone) => {
        if (!phone) return null;
        const digits = phone.trim();
        if (digits.length === 10) return `(${digits.substring(0, 2)}) ${digits.substring(2, 6)}-${digits.substring(6, 10)}`;
        if (digits.length === 11) return `(${digits.substring(0, 2)}) ${digits.substring(2, 7)}-${digits.substring(7, 11)}`;
        return phone;
    }

    const getPrimaryPhone = (item) => item.phone || item.phone2 || '';
    const getPrimaryWhatsapp = (item) => item.whatsapp || item.whatsapp2 || '';

    const companyStores = [
        {
            label: 'Loja 1',
            address: `${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}`,
            phone: getPrimaryPhone(company),
            whatsapp: getPrimaryWhatsapp(company),
            whatsappDefaultMessage: company.whatsappDefaultMessage
        },
        ...subsidiaries.map((item, index) => ({
            label: `Loja ${index + 2}`,
            address: `${item.address} - ${item.city} - ${item.federativeUnit} - ${item.postalCode}`,
            phone: getPrimaryPhone(item),
            whatsapp: getPrimaryWhatsapp(item),
            whatsappDefaultMessage: item.whatsappDefaultMessage
        }))
    ];

    return (
        <section className="contact-section ptb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8">
                        <div className="contact-form-area bg-white rounded iv_sidebar_widget iv_seller_widget widget-padding">
                            <h4 className="mb-3">Entre em Contato</h4>
                            <p className="mb-4">Caso tenha alguma dúvida, agendamento de uma visita ou test-drive preencha o formulário. Retornaremos o mais breve possível.</p>
                            <form onSubmit={handleSubmit(onSubmit)} className="ct-form-wrapper">
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="input-field">
                                            <label>Nome</label>
                                            <input type="text" placeholder="Nome Completo" {...register("txtName", { required: true })} required={errors.txtName} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-field">
                                            <label>Email</label>
                                            <input type="email" placeholder="Email" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-field">
                                            <label>Celular</label>
                                            <InputMask type={'tel'} mask="(99) 99999-9999" maskChar=" " placeholder="Celular" {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="input-field">
                                            <label>Mensagem</label>
                                            <textarea placeholder="Mensagem" rows="5" {...register("txtMessage", { required: true })} required={errors.txtMessage}></textarea>
                                        </div>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="success-badge bg-primary-success rounded d-block">Contato enviado com sucesso, aguarde o retorno de nossa equipe!</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                <button className="btn btn-primary btn-md mt-4" disabled={formPost.isLoading} type="submit">Enviar Mensagem</button>
                            </form>
                        </div>
                    </div>
                    <div className="col-xl-4">
                        <div className="contact-sidebar-widget py-5 px-4 bg-white rounded mt-5 mt-xl-0">
                            {companyStores.map((store, index) => (
                                <div key={index}>
                                    <h4 className="mb-4">Contatos - {store.label === 'Matriz' ? 'Matriz' : store.label}</h4>
                                    <ul className="fs-md">
                                        <li className="fw-500"><strong className="fw-bold text-secondary">Endereço: </strong>{store.address}</li>
                                    </ul>
                                    <hr className="mt-4 mb-4" />
                                    <ul className="contact-info">
                                        {store.phone ? (
                                            <li className="d-flex align-items-center">
                                                <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-solid fa-phone"></i></span>
                                                <div className="ms-3 info-content">
                                                    <span className="d-block">Telefone:</span>
                                                    <a href={`tel:+55${store.phone}`}>{formatPhone(store.phone)}</a>
                                                </div>
                                            </li>
                                        ) : null}
                                        {store.whatsapp ? (
                                            <li className="d-flex align-items-center">
                                                <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-brands fa-whatsapp"></i></span>
                                                <div className="ms-3 info-content">
                                                    <span className="d-block">Whatsapp:</span>
                                                    <a target="_blank" rel="noreferrer" href={`https://api.whatsapp.com/send?phone=${store.whatsapp}&text=${encodeURIComponent(store.whatsappDefaultMessage || 'Olá, gostaria de tirar algumas dúvidas com um consultor. Alguém disponível para me atender agora?')}`}>{formatPhone(store.whatsapp)}</a>
                                                </div>
                                            </li>
                                        ) : null}
                                    </ul>
                                    <hr className="mt-30 mb-40" />
                                </div>
                            ))}
                            <h4 className="mb-4">E-mail</h4>
                            <ul className="contact-info">
                                <li className="d-flex align-items-center">
                                    <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-regular fa-envelope"></i></span>
                                    <div className="ms-3 info-content">
                                        <span className="d-block">Email:</span>
                                        <a href={`mailto:${company.email}`}><p>{company.email}</p></a>
                                    </div>
                                </li>
                            </ul>
                            <hr className="mt-30 mb-40" />
                            <h6 className="mb-3">Redes Sociais</h6>
                            <div className="contact-social">
                                {company.instagram ? <a href={company.instagram} target='_blank' rel="noreferrer"><i className="fab fa-instagram"></i></a> : null}
                                {company.facebook ? <a href={company.facebook} target='_blank' rel="noreferrer"><i className="fab fa-facebook-f"></i></a> : null}
                                {company.youtube ? <a href={company.youtube} target='_blank' rel="noreferrer"><i className="fab fa-youtube"></i></a> : null}
                                {company.tiktok ? <a href={company.tiktok} target='_blank' rel="noreferrer"><i className="fab fa-tiktok"></i></a> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}